<lib-app-button data-testid="delete-cache-button" id="present-warning" fill="clear" size="default">
  <ion-label>{{ 'menu.deviceSettings.deleteCache.deleteCacheButton' | transloco }}</ion-label>
</lib-app-button>

<ion-alert
  trigger="present-warning"
  [header]="'menu.deviceSettings.deleteCache.deleteConfirmationDialog.title' | transloco"
  [message]="'menu.deviceSettings.deleteCache.deleteConfirmationDialog.message' | transloco"
  [buttons]="alertButtons"
></ion-alert>
